module.exports = __webpack_public_path__ + "img/3_l_no.5e47256b.svg";